import { useGetServers } from "../hooks/useGetServers";
import './styles/ServerList.css';

const CommonServerList: React.FC<{isInternal: boolean}> = ({isInternal}) => {
    const { servers, isLoading, error } = useGetServers(isInternal);

    return (
        <div className='glass-ui server-list'>
            {isLoading &&
                <div className='server-list-item'>
                    Загрузка серверов...
                </div>
            }
            {!isLoading && !error && servers && servers.length > 0 && (
                <>
                    {servers.map((s) => (
                        <div className='server-list-item' key={s.name}>
                            <div className="server-list-item-left">
                                {s.isActive ?
                                    <div className="server-status-active" /> :
                                    <div className="server-status-inactive" />
                                }
                                <div className="server-name">{s.name}</div>
                            </div>
                            <div className='server-list-item-right'>
                                {s.isActive ?

                                    <span className="server-latency">
                                        задержка: {s.ping}мс
                                    </span> :
                                    <span className="server-latency">
                                        недоступен ⚠️
                                    </span>

                                }
                            </div>
                        </div>
                    ))}
                </>
            )}
        </div>
    );
};

export default CommonServerList;